import React, { useState } from 'react';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from '../firebase';
import { doc, setDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

const RegisterForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Mentés Firestore-ba
      await setDoc(doc(db, 'users', user.uid), {
        email: user.email,
        createdAt: new Date(),
        role: 'user'
      });

      console.log('✅ Sikeres regisztráció:', user.email);
      navigate('/profil'); // Átirányítás regisztráció után
    } catch (err) {
      console.error('❌ Hiba a regisztrációnál:', err.message);
      switch (err.code) {
        case 'auth/email-already-in-use':
          setError('Ez az email cím már használatban van');
          break;
        case 'auth/invalid-email':
          setError('Érvénytelen email cím');
          break;
        case 'auth/weak-password':
          setError('A jelszónak legalább 6 karakter hosszúnak kell lennie');
          break;
        default:
          setError('Ismeretlen hiba történt');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <main style={{ padding: '2rem', fontFamily: 'Arial, sans-serif', maxWidth: '400px', margin: '0 auto' }}>
      <h2 style={{ color: '#b30000', textAlign: 'center', marginBottom: '1rem' }}>Regisztráció</h2>

      <form onSubmit={handleRegister} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={{
            padding: '0.5rem',
            fontSize: '1rem',
            borderRadius: '4px',
            border: '1px solid #ccc'
          }}
        />
        <input
          type="password"
          placeholder="Jelszó"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={{
            padding: '0.5rem',
            fontSize: '1rem',
            borderRadius: '4px',
            border: '1px solid #ccc'
          }}
        />
        <button
          type="submit"
          disabled={loading}
          style={{
            backgroundColor: '#b30000',
            color: 'white',
            padding: '0.5rem',
            fontWeight: 'bold',
            border: 'none',
            borderRadius: '5px',
            cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.6 : 1
          }}
        >
          {loading ? 'Regisztrálás...' : 'Regisztráció'}
        </button>
        {error && (
          <div style={{ color: 'red', fontSize: '0.9rem', textAlign: 'center' }}>
            {error}
          </div>
        )}
      </form>
    </main>
  );
};

export default RegisterForm;
